import { approvedVendorQuery } from "@common/api"
import { Card } from "@common/components/ui/card"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { VendorForm } from "@/routes/_layout/approved-vendors/-components/form/vendor-form"

export const Route = createFileRoute("/_layout/approved-vendors_/$vendorId")({
  loader: async ({ context: { queryClient }, params: { vendorId } }) => {
    const vendor = await queryClient.ensureQueryData(
      approvedVendorQuery({ vendor_id: vendorId }),
    )
    return {
      breadcrumb: [
        { label: "Approved vendors", href: "/approved-vendors" },
        { label: vendor.name },
      ],
    }
  },
  component: EditVendorPage,
})

function EditVendorPage(): React.ReactElement {
  const { vendorId } = Route.useParams()
  const { data: vendor } = useSuspenseQuery(
    approvedVendorQuery({ vendor_id: vendorId }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () => navigate({ to: "/approved-vendors", search: true })

  return (
    <div className="h-full overflow-y-auto">
      <PageContent>
        <PageTitle title={vendor.name} />
        <Card className="p-4 shadow-none">
          <VendorForm
            vendor={vendor}
            onSaved={() => {
              showToast("Saved", "Vendor updated.", "success")
              close()
            }}
            onCancel={close}
          />
        </Card>
      </PageContent>
    </div>
  )
}
